import {Device} from "../../types/device";
import {Link} from "react-router-dom";
import {useCompareStore} from "../../stores/useCompateStore";

type DeviceRowProps = {
    device: Device;
}

export default function DeviceRow({device}: DeviceRowProps) {
    const ids = useCompareStore((state) => state.ids);
    const addToCompare = useCompareStore((state) => state.addToCompare);
    const removeFromCompare = useCompareStore((state) => state.removeFromCompare);
    const {isFull} = useCompareStore();
    const isComparing = ids.includes(device.id);

    const compareClick = (e: React.MouseEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (isComparing) {
            removeFromCompare(device.id);
        } else if (!isFull()) {
            addToCompare(device.id);
        }
    };

    return (
        <Link to={`/phones/${device.id}`} className="block no-underline text-inherit">
            <div className="grid grid-cols-[auto_1fr_auto] gap-6 p-6 border rounded-lg bg-white">
                <div className="flex items-start">
                    <img src={device.image_url ? device.image_url : ""} className="w-40 object-contain" alt="Phone"/>
                </div>

                <div className="flex flex-col gap-2 ">
                    <h2 className="text-xl font-semibold">
                        {device.brand} {device.model}
                    </h2>

                    <p className="text-sm text-gray-700">
                        <span
                            className="font-medium">Screen:</span> {device.screen_size_inch}", {device.screen_type}, {device.screen_resolution}{device.refresh_rate_hz ? `, ${device.refresh_rate_hz} Hz` : null}
                    </p>

                    <p className="text-sm text-gray-700">
                        <span className="font-medium">Camera:</span> {device.main_camera_mp} MP
                        {device.telephoto_camera_mp ? `+ ${device.telephoto_camera_mp} MP` : null} {device.ultrawide_camera_mp ? `+ ${device.ultrawide_camera_mp} MP` : null}
                        {/*3 modules, 48 MP + 48 MP + 48 MP*/}
                    </p>

                    <p className="text-sm text-gray-700">
                        <span
                            className="font-medium">Memory:</span> {device.storage_gb.map((gb) => `${gb} GB`).join(", ")}
                    </p>

                    <p className="text-sm text-gray-700">
                        <span className="font-medium">CPU:</span> {device.cpu_cores} cores
                        <span className="ml-4 font-medium">RAM:</span> {device.ram_gb} GB
                    </p>

                    <p className="text-sm text-gray-700">
                        <span className="font-medium">Battery:</span> {device.battery_capacity_mah} mAh
                    </p>
                </div>

                <div className="grid grid-cols-[1fr_auto] gap-x-4 gap-y-2 text-sm">
                    <div className="font-semibold col-span-2 text-right">
                        from € to €
                    </div>

                    <div>shop.ie</div>
                    <div className="text-right">€</div>

                    <div>shop.ie</div>
                    <div className="text-right">€</div>

                    <div>shop.ie</div>
                    <div className="text-right">€</div>

                    <div className="flex items-center gap-2 text-sm" onClick={(e) => e.stopPropagation()}>
                        <input
                            type="checkbox"
                            id={`compare-${device.id}`}
                            disabled={!isComparing && isFull()}
                            checked={isComparing}
                            onChange={()=>{}}
                            onClick={compareClick} // Use onChange instead of onClick
                            className="cursor-pointer disabled:cursor-not-allowed"
                            title={!isComparing && isFull() ? "Comparison list is full!" : ""}
                        />
                        <label
                            htmlFor={`compare-${device.id}`}
                            className={`select-none ${
                                !isComparing && isFull() ? "text-gray-400 cursor-not-allowed" : "text-slate-700 cursor-pointer"
                            }`}
                            title={!isComparing && isFull() ? "Comparison list is full!" : ""}
                        >
                            Compare
                        </label>
                    </div>
                </div>
            </div>


        </Link>

    )
        ;
}